import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AppService } from '../app.service';
import { Location } from '@angular/common';
@Component({
  selector: 'app-employeemaster',
  templateUrl: './employeemaster.component.html',
  styleUrls: ['./employeemaster.component.scss']
})
export class EmployeemasterComponent implements OnInit {
  employeeForm: FormGroup;
  constructor(private fb: FormBuilder,
    private toastr: ToastrService,
    private appservice: AppService, public location: Location) {
    this.employeeForm = this.fb.group({
      empId: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      designation: ['', Validators.required],
      grade: ['', [Validators.required, Validators.required]],

      department: ['', Validators.required],
      doj: ['', Validators.required]
    });
  }
  employees = [
    { id: 1, name: 'Alice', department: 'HR', salary: 50000 },
    { id: 2, name: 'Bob', department: 'Engineering', salary: 75000 },
    { id: 3, name: 'Charlie', department: 'Marketing', salary: 60000 }
  ];
  public CheckerApproverdata: any = [];

  public add: any = {}
  public rec: any = [];
  public ErrorMessage: string = '';
  public Designation: any = [];
  public plant: any = [];
  validate() {
    if (this.add.Em_Empcode == undefined || this.add.Em_Empcode == '') {
      this.ErrorMessage = "Please Enter Employee ID";
      return false;
    }
    if (this.add.Em_Firstname == undefined || this.add.Em_Firstname == '') {
      this.ErrorMessage = "Please Enter First Name";
      return false;
    }
    if (this.add.Em_Lastname == undefined || this.add.Em_Lastname == '') {
      this.ErrorMessage = "Please Enter Last Name";
      return false;
    }
    if (this.add.Em_Designation == undefined || this.add.Em_Designation == '') {
      this.ErrorMessage = "Please Enter Designation";
      return false;
    }
    if (this.add.Em_Grade == undefined || this.add.Em_Grade == '') {
      this.ErrorMessage = "Please Enter Grade";
      return false;
    }
    if (this.add.Em_Department == undefined || this.add.Em_Department == '') {
      this.ErrorMessage = "Please Enter Department";
      return false;
    }
    if (this.add.Em_DateofJoin == undefined || this.add.Em_DateofJoin == '') {
      this.ErrorMessage = "Please Enter Date of Join";
      return false;
    } if (this.add.Em_Plant == undefined || this.add.Em_Plant == '') {
      this.ErrorMessage = "Please Enter Plant";
      return false;
    } if (this.add.Em_Roll == undefined || this.add.Em_Roll == '') {
      this.ErrorMessage = "Please Enter Roll";
      return false;
    } if (this.add.Em_Email == undefined || this.add.Em_Email == '') {
      this.ErrorMessage = "Please Enter Email";
      return false;
    } if (this.add.Em_PhoneNo == undefined || this.add.Em_PhoneNo == '') {
      this.ErrorMessage = "Please Enter Phone No";
      return false;
    }
    this.ErrorMessage = '';
    return true;
  }
  get_CheckerApproverdata() {
    this.appservice.getTable("api/Master/GetCheckerApproverdata").subscribe((res: any) => {
      this.CheckerApproverdata = res
      //this.rec=JSON.parse(res);



    });
  }

  cancelEdit() {
  this.appservice.empmastereditid = '';
  this.add = {};
  this.location.back();
}
  getstaffid() {
    this.appservice.getTable("Api/Transaction/GetStaff_details").subscribe((res: any) => {
      if (typeof res === 'string') {
        try {
          // Remove control characters before parsing
          //const clean = res.replace(/[\u0000-\u001F\u007F]/g, '');
          this.CheckerApproverdata = JSON.parse(res);
        } catch (e) {
          console.error("Cleaned JSON parse error:", e);
          this.CheckerApproverdata = [];
        }
      } else {
        this.CheckerApproverdata = res;
        // console.log("the checker", this.CheckerApproverdata)
      }
    });
  }
  onSubmit() {
    // event.preventDefault();event: Event

    if (this.validate()) {
      console.log("the Selected id", this.add.Em_Checker_id);
      this.add.Em_Checker_Approvedby = this.CheckerApproverdata.filter((x: any) => x.Em_iid == this.add.Em_Checker_id)[0].Em_First_Name + " " + this.CheckerApproverdata.filter((x: any) => x.Em_iid == this.add.Em_Checker_id)[0].Em_lastName;
      this.appservice.postTable("api/Master/insert_EmployeeMaster", this.add).subscribe((res: any) => {
        if (res != '') {
          this.toastr.success('Employee Details Saved Successfully');
          this.location.back();
        }

      });
      //this.toastr.success("Master Saved successfully!");

    } else {
      this.toastr.warning(this.ErrorMessage);
    }
  }
  departmentdata: any[] = [];
  ngOnInit(): void {
    console.log(this.appservice.empmastereditid)
    if (this.appservice.empmastereditid != '') {
      this.appservice.getTable("api/Transaction/GetEmployeedetailsbyid?id=" + this.appservice.empmastereditid).subscribe((res: any) => {
        this.rec = this.appservice.getJsondata(res)
        //this.rec=JSON.parse(res);
        this.add.EM_iid = this.rec[0].Em_iid;
        this.add.Em_Empcode = this.rec[0].Em_Empcode;
        this.add.Em_Firstname = this.rec[0].Em_First_Name;
        this.add.Em_Lastname = this.rec[0].Em_lastName;
        this.add.Em_Designation = this.rec[0].Em_Designation;
        this.add.Em_Grade = this.rec[0].Em_Grade;
        this.add.Em_Department = this.rec[0].Em_Department;
        this.add.Em_Plant = this.rec[0].Em_Plant;
        this.add.Em_Roll = this.rec[0].Em_Roll;
        this.add.Em_Email = this.rec[0].Em_Email;
        this.add.Em_DateofJoin = this.appservice.formatCustomDate(this.rec[0].Em_DateofJoin);
        this.add.Em_PhoneNo = this.rec[0].Em_PhoneNo;
        this.add.Em_ADUserName = this.rec[0].Em_ADUserName;
        //console.log("the values",this.add);

        console.log("the values", this.rec[0].Em_DateofJoin);
      });
    }
    this.departmentdata = this.appservice.fetchDepartment();
    this.Designation = this.appservice.fetchDesignation();
    this.plant = this.appservice.fetchplant();
    this.getstaffid();
  }
}
